import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { cn } from '../../src/lib/utils';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'section' | 'li' | 'article';
  id?: string;
};

/** Gentle entrance fade that respects prefers-reduced-motion. */
export function Reveal({
  children,
  className,
  delay = 0,
  as = 'div',
  id
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as];
  if (reduceMotion) {
    const Tag = as;
    return <Tag className={className} id={id} data-id="element-502" data-mp="1rd82ma4b223">
        {children}
      </Tag>;
  }
  return <MotionTag id={id} className={cn(className)} initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-503" data-mp="fhytahn1no35">
      {children}
    </MotionTag>;
}